import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const TrustSection = () => {
  const clients = [
    {
      name: 'LOGIFAC',
      type: 'Résidence étudiante',
      description: 'Partenaire de confiance pour la rénovation et l\'entretien de logements étudiants',
      logo: '/logo-logifac.jpeg'
    },
    {
      name: 'COGERIM',
      type: 'Société de gestion immobilière',
      description: 'Travaux complets de rénovation : peinture, plâtrerie, plomberie, sols et carrelage',
      logo: '/logo-cogerim.jpeg'
    }
  ];

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50/30 via-transparent to-blue-50/30"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-2xl mb-6">
            <CheckCircle2 className="text-blue-600" size={32} />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Ils nous font confiance
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Bailleurs et résidences étudiantes qui nous accordent leur confiance pour leurs travaux
          </p>
        </div>

        {/* Clients Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-12">
          {clients.map((client, index) => (
            <Card
              key={index}
              className="group bg-white border-2 border-gray-100 hover:border-blue-200 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
            >
              <CardContent className="p-8">
                <div className="flex flex-col items-center text-center space-y-4">
                  {/* Logo */}
                  <div className="w-full h-32 flex items-center justify-center bg-white rounded-xl p-4 shadow-md">
                    <img
                      src={client.logo}
                      alt={`${client.name} Logo`}
                      className="max-w-full max-h-full object-contain"
                    />
                  </div>
                  
                  <div className="w-full">
                    <p className="text-sm font-semibold text-blue-600 mb-3">
                      {client.type}
                    </p>
                    <p className="text-gray-600 leading-relaxed">
                      {client.description}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Stats Bar */}
        <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 rounded-3xl shadow-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">500+</div>
              <div className="text-blue-100 font-medium">Logements rénovés</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">15+</div>
              <div className="text-blue-100 font-medium">Années d'expérience</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">100%</div>
              <div className="text-blue-100 font-medium">Satisfaction client</div>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="mt-12 flex flex-wrap justify-center items-center gap-6">
          <div className="flex items-center space-x-2 bg-blue-50 px-6 py-3 rounded-full">
            <CheckCircle2 className="text-blue-600" size={20} />
            <span className="text-gray-700 font-medium">Entreprise certifiée</span>
          </div>
          <div className="flex items-center space-x-2 bg-blue-50 px-6 py-3 rounded-full">
            <CheckCircle2 className="text-blue-600" size={20} />
            <span className="text-gray-700 font-medium">Garantie décennale</span>
          </div>
          <div className="flex items-center space-x-2 bg-blue-50 px-6 py-3 rounded-full">
            <CheckCircle2 className="text-blue-600" size={20} />
            <span className="text-gray-700 font-medium">Assurance RC Pro</span>
          </div>
        </div>
      </div>
    </section>
  );
};
